import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getAccountSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/accountSummary`
    },
    getAddOnsInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/pricingPlans/addOns`
    },
    getPricingPlans: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/pricingPlans/addOns`
    },
    getPaymentMethod: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/paymentMethod`
    },
    previewRatePlan: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/subscription/rateplan`
    },
    placeOrder: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/subscription/rateplan`
    },
    getFutureDatedAmendment: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/futureDatedAmendment`
    },
    getBillingInvoices: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/invoices`
    },
    getSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/summary`
    }
};

export function BillingApi() {
    const service = createActions(actions);

    service.getBuildiumInvoiceReportUrl = function getBuildiumInvoiceReportUrl(params) {
        return `${BASE_PATH_API}/billing/invoices/report${params}`;
    };
    service.getEPayActivityReportURL = function getEPayActivityReportURL(params) {
        return `${BASE_PATH_API}/billing/ePayActivity/report${params}`;
    };
    service.get1099ActivityReportUrl = function get1099ActivityReportUrl(params) {
        return `${BASE_PATH_API}/billing/batch1099/report${params}`;
    };
    service.getBasicScreeningActivityReportUrl = function getBasicScreeningActivityReportUrl(params) {
        return `${BASE_PATH_API}/billing/usage/basicscreening/report${params}`;
    };
    service.getPremiumScreeningActivityReportUrl = function getPremiumScreeningActivityReportUrl(params) {
        return `${BASE_PATH_API}/billing/usage/premiumscreening/report${params}`;
    };
    service.getELeaseActivityReportUrl = function getELeaseActivityReportUrl(params) {
        return `${BASE_PATH_API}/billing/usage/elease/report${params}`;
    };
    service.getESignatureActivityReportUrl = function getESignatureActivityReportUrl(params) {
        return `${BASE_PATH_API}/billing/usage/esignature/report${params}`;
    };
    return service;
}
BillingApi.$inject = [];
